import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

// A blocking yes/no for the things that cannot be undone. It sits on top of
// whatever opened it, including another modal, so the vendor logins list can
// use it without closing itself first.
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  busy = false,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
      <div className="bg-white rounded-lg w-full max-w-md p-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 rounded-full bg-red-100 p-2">
            <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
          </div>
          <div className="min-w-0">
            <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
            <div className="mt-2 text-sm text-gray-600 space-y-2">{message}</div>
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="px-4 py-2 text-sm border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className="px-4 py-2 text-sm rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
          >
            {busy ? 'Working...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
